import Splitting from 'splitting';

const staggerText = (el, elToAnim) => {
  const innerHtml = el.innerHTML;
  const instance = Splitting({ target: el, by: 'lines' });

  elToAnim.push({
    node: el,
    innerHtml,
    instance,
  });
};

export default staggerText;
